import { isEmpty } from 'lodash';

import Partner from 'hb-react/shared/apps/Topics/components/Partners/Partner';
import { topicElementIsVisibleOnPublicPage } from 'hb-react/shared/apps/Topics/utils/topicElementIsVisibleOnPublicPage';

import style from '../index.module.scss';

const PartnersWrapper = ({ topic, currentUser, partnerStore, getBgColor }) => {
  const partners = topic.partners
    .map((partnerId) => partnerStore.getIn(['partners', partnerId.toString()]))
    .map((partner) => <Partner key={partner.get('id')} {...partner.toJS()} />);

  return (
    topic.home_config.section_partners_enabled &&
    topicElementIsVisibleOnPublicPage(currentUser, topic, 'partners') &&
    !isEmpty(partners) && (
      <div
        className="flex soft-double--bottom"
        style={{
          backgroundColor: getBgColor(
            topic.home_config.section_partners_body_background_color,
          ),
        }}
      >
        <div className="relative push-half--bottom soft-half-push flex-grow--1 width--100-percent">
          <h2
            className="h1 soft-double--ends"
            style={{
              color: topic.home_config.section_partners_title_color,
              backgroundColor:
                topic.home_config.section_partners_title_background_color,
              textAlign: topic.home_config.section_partners_title_alignment,
            }}
          >
            <div className={`style['homepage-container']`}>
              {topic.home_config.section_partners_title || __('Partners')}
            </div>
          </h2>
          {!isEmpty(topic.partners) && (
            <div className={`grid grid--full ${style['homepage-container']}`}>
              {partners}
            </div>
          )}
        </div>
      </div>
    )
  );
};

export default PartnersWrapper;
